import React from 'react';
var SIZE = 50;
var styles = {
  root: {
    display: 'flex',
    width: 40,
    height: 40,
    color: '#206cff'
  },
  spinner: {
    width: 'inherit',
    animation: 'spinnerRotate 2s linear infinite',
    transformOrigin: 'center center',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 0
  },
  circle: {
    stroke: 'currentColor',
    strokeDasharray: '1, 100',
    strokeDashoffset: 0,
    animation: 'spinnerPathDash 1.5s ease-in-out infinite',
    strokeLinecap: 'round'
  },
  '@keyframes spinnerRotate': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  '@keyframes spinnerPathDash': {
    '0%': {
      strokeDasharray: '1, 200',
      strokeDashoffset: 0
    },
    '50%': {
      strokeDasharray: '89, 200',
      strokeDashoffset: '-35px'
    },
    '100%': {
      strokeDasharray: '89, 200',
      strokeDashoffset: '-124px'
    }
  }
};
var Spinner = function Spinner() {
  return /*#__PURE__*/React.createElement("div", {
    style: styles.root,
    "data-qa": "spinner"
  }, /*#__PURE__*/React.createElement("svg", {
    style: styles.spinner,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React.createElement("circle", {
    style: styles.circle,
    cx: SIZE,
    cy: SIZE,
    r: "20",
    fill: "none",
    strokeWidth: "3.6",
    strokeMiterlimit: "10"
  })));
};
export default Spinner;